<template>
    <v-card>
        <v-card-title>
            <v-toolbar dense flat>
                <v-text-field
                        solo
                        flat
                        autofocus
                        autocomplete="off"
                        prepend-inner-icon="search"
                        placeholder="搜索图标(英文)"
                        hide-details
                        clearable
                        v-model="searchText"
                        @keydown="queryIcons"
                ></v-text-field>
            </v-toolbar>
        </v-card-title>
        <v-card-text>
            <div style="overflow: auto;">
                <v-card class="text-break d-flex flex-wrap">
                    <v-card-text v-if="showIcons.length==0&&searchText_&&searchText_.length>0">
                        <div>搜索不到图标{{searchText_}}</div>
                    </v-card-text>
                    <div v-for="icon in showIcons" :key="icon" class="ma-1 pa-1"
                         style="width: 100px;height: 50px;text-align:center;cursor:pointer" @click="selectIcon(icon)">
                        <v-icon>mdi-{{icon}}</v-icon>
                        <div style="white-space: nowrap;text-overflow:ellipsis;max-width: 100px;overflow: hidden;">
                            {{icon}}
                        </div>

                    </div>
                </v-card>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import {mdiIconNames} from './MdiIconName'

    export default {
        name: "IconSelector",
        props: {
            pageSize: {
                type: Number,
                default: 40
            }
        },
        data() {
            return {
                mdiIcons: mdiIconNames,
                page: 1,
                searchText: null,
                searchText_: null,
                iconContainer: [],
                showIcons: []
            }
        },
        created() {
        },
        watch: {
            page() {
                this.updateShowIcons();
            }
        },
        methods: {
            queryIcons: function (e) {
                if (e.keyCode === 13) {
                    this.updateShowIcons();
                }
            },
            updateShowIcons() {
                if (this.searchText == null || this.searchText.length == 0) {
                    this.iconContainer = this.mdiIcons;
                } else {
                    this.iconContainer = this.mdiIcons.filter(item => item.indexOf(this.searchText) >= 0);
                }
                this.showIcons = [];
                this.showIcons = this.iconContainer;
                this.searchText_ = this.searchText;
            },
            selectIcon(icon) {
                this.$emit('selectIcon', 'mdi-' + icon);
            }
        }
    }
</script>
